import { sf_hinhthucmiengiam_group } from "../../models/response/hinh-thuc-mien-giam/sf_hinhthucmiengiam_group"
import {
    HinhThucMienGiamGroupActionTypeIds,
    HinhThucMienGiamGroupChangeSelectedIdsAction,
    HinhThucMienGiamGroupCloseDetailModalAction,
    HinhThucMienGiamGroupDeleteErrorAction,
    HinhThucMienGiamGroupDeleteStartAction, HinhThucMienGiamGroupDeleteSuccessAction,
    HinhThucMienGiamGroupLoadErrorAction,
    HinhThucMienGiamGroupLoadStartAction, HinhThucMienGiamGroupLoadSuccessAction,
    HinhThucMienGiamGroupSaveErrorAction,
    HinhThucMienGiamGroupSaveStartAction, HinhThucMienGiamGroupSaveSuccessAction,
    HinhThucMienGiamGroupShowDeleteConfirmAction,
    HinhThucMienGiamGroupShowDetailModalAction
} from "../action-types/hinhThucMienGiamGroupActionTypes"

export const loadHinhThucMienGiamGroupStart = (): HinhThucMienGiamGroupLoadStartAction => {
    return {
        type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_LOAD_START
    }
}

export const loadHinhThucMienGiamGroupSuccess = (payload: sf_hinhthucmiengiam_group[]): HinhThucMienGiamGroupLoadSuccessAction => {
    return {
        type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_LOAD_SUCCESS,
        payload: payload
    }
}
export const loadHinhThucMienGiamGroupError = (payload: string): HinhThucMienGiamGroupLoadErrorAction => {
    return {
        type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_LOAD_ERROR,
        payload: payload
    }
}

export const showHinhThucMienGiamGroupDetailModal = (payload?: sf_hinhthucmiengiam_group): HinhThucMienGiamGroupShowDetailModalAction => {
    return {
        type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SHOW_DETAIL_MODAL,
        payload: payload
    }
}
export const closeHinhThucMienGiamGroupDetailModal = (): HinhThucMienGiamGroupCloseDetailModalAction => {
    return {
        type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_CLOSE_DETAIL_MODAL,
    }
}
export const showHinhThucMienGiamGroupDeleteConfirm = (payload: boolean): HinhThucMienGiamGroupShowDeleteConfirmAction => {
    return {
        type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SHOW_DELETE_CONFIRM,
        payload: payload
    }
}

export const saveHinhThucMienGiamGroupStart = (payload: sf_hinhthucmiengiam_group): HinhThucMienGiamGroupSaveStartAction => {
    return {
        type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SAVE_START,
        payload: payload
    }
}

export const saveHinhThucMienGiamGroupSuccess = (payload: sf_hinhthucmiengiam_group): HinhThucMienGiamGroupSaveSuccessAction => {
    return {
        type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SAVE_SUCCESS,
        payload: payload
    }
}
export const saveHinhThucMienGiamGroupError = (payload: string): HinhThucMienGiamGroupSaveErrorAction => {
    return {
        type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SAVE_ERROR,
        payload: payload
    }
}

export const deleteHinhThucMienGiamGroupStart = (payload: number[]): HinhThucMienGiamGroupDeleteStartAction => {
    return {
        type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_DELETE_START,
        payload: payload
    }
}

export const deleteHinhThucMienGiamGroupSuccess = (payload: number[]): HinhThucMienGiamGroupDeleteSuccessAction => {
    return {
        type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_DELETE_SUCCESSS,
        payload: payload
    }
}
export const deleteHinhThucMienGiamGroupError = (payload: string): HinhThucMienGiamGroupDeleteErrorAction => {
    return {
        type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_DELETE_ERROR,
        payload: payload
    }
}

export const changeHinhThucMienGiamGroupSelectionIds = (payload: number[]): HinhThucMienGiamGroupChangeSelectedIdsAction => {
    return {
        type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_CHANGE_SELECTED_IDS,
        payload: payload
    }
}